<template>
  <div class="md:flex md:items-center md:justify-between">
    <div class="min-w-0 flex-1">
      <h2 class="text-2xl/7 font-bold text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">{{ title }}</h2>
    </div>
    <div class="mt-6 flex items-center justify-end gap-x-6">
    <button type="button" @click="onCancel" class="text-sm/6 font-semibold text-gray-900">{{ $gettext("Annuler") }}</button>
    <button type="button" @click="onSubmit" class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">{{ $gettext("Enregistrer") }}</button>
  </div>
  </div>
</template>

<script setup>
defineProps(["title"]);
const emits = defineEmits(["cancel", "submit"]);

const onCancel = (() => {
  emits("cancel");
});

const onSubmit = (() => {
  emits("submit");
});
</script>
